import { buildDownloadAppQrUrl } from 'utils/downloadAppQuery';

export const GUEST_LOGIN_STEPS = [
    'Tap "Guest Login"',
    'Tap "Create your password"',
    'Enter your registered email to receive your password link',
];

export const DOWNLOAD_APP_HEADINGS = {
    DOWNLOAD: 'Download Our App',
    CONTINUE_ON_APP: 'Continue On App',
};

export const GUEST_LOGIN_SUBHEADING = 'After downloading the app:';

export const DEFAULT_QR_CODE_SIZE = '250px';

export const CONTINUE_BUTTON_LABELS = {
    BROWSER: 'Continue in Browser',
    WEB: 'Continue on Web',
};

/** QR target for /download-app; includes eventId/pageId when in event context. */
export const getDownloadAppPageQrUrl = (eventId = '', pageId = '') =>
    buildDownloadAppQrUrl(window.location.origin, { eventId, pageId });
